"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateRecordGivings = exports.validateRecordFyDownload = exports.updateRecordGivings = exports.recordsValidationErrorDownload = exports.recordImportSuccess = exports.recordImportReset = exports.recordImportError = exports.importRecordsValidation = exports.importRecordsFyDownloads = exports.importRecords = exports.downloadRecordGivingErrorSheet = exports.downloadRecordFyErrorSheet = void 0;
var _recordImport = require("./recordImport.constant");
// @flow

// common success
var recordImportSuccess = function recordImportSuccess(actionType, data) {
  return {
    type: _recordImport.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.recordImportSuccess = recordImportSuccess;
var recordImportError = function recordImportError(actionType, error) {
  return {
    type: _recordImport.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * import records validation
 * @param payload
 * @returns api response
 * @description this function used to import records validation.
 */
exports.recordImportError = recordImportError;
var importRecordsValidation = function importRecordsValidation(data) {
  return {
    type: _recordImport.actionTypes.IMPORT_RECORDS_VALIDATION,
    payload: data
  };
};

/**
 * validate record givings
 * @param payload
 * @returns api response
 * @description this function used to validate record givings.
 */
exports.importRecordsValidation = importRecordsValidation;
var validateRecordGivings = function validateRecordGivings(data) {
  return {
    type: _recordImport.actionTypes.VALIDATE_RECORD_GIVINGS,
    payload: data
  };
};

/**
 * validate record fy download
 * @param payload
 * @returns api response
 * @description this function used to validate record fy download.
 */
exports.validateRecordGivings = validateRecordGivings;
var validateRecordFyDownload = function validateRecordFyDownload(data) {
  return {
    type: _recordImport.actionTypes.VALIDATE_RECORD_FY_DOWNLOAD,
    payload: data
  };
};

/**
 * import records
 * @param payload
 * @returns api response
 * @description this function used to import records.
 */
exports.validateRecordFyDownload = validateRecordFyDownload;
var importRecords = function importRecords(data) {
  return {
    type: _recordImport.actionTypes.IMPORT_RECORDS,
    payload: data
  };
};

/**
 * import records fy downloads
 * @param payload
 * @returns api response
 * @description this function used to import records fy downloads.
 */
exports.importRecords = importRecords;
var importRecordsFyDownloads = function importRecordsFyDownloads(data) {
  return {
    type: _recordImport.actionTypes.IMPORT_RECORDS_FY_DOWNLOADS,
    payload: data
  };
};

/**
 * update record givings
 * @param payload
 * @returns api response
 * @description this function used to update record givings.
 */
exports.importRecordsFyDownloads = importRecordsFyDownloads;
var updateRecordGivings = function updateRecordGivings(data) {
  return {
    type: _recordImport.actionTypes.UPDATE_RECORD_GIVINGS,
    payload: data
  };
};

/**
 * records validation error download
 * @param payload
 * @returns api response
 * @description this function used to records validation error download.
 */
exports.updateRecordGivings = updateRecordGivings;
var recordsValidationErrorDownload = function recordsValidationErrorDownload(data) {
  return {
    type: _recordImport.actionTypes.RECORDS_VALIDATION_ERROR_DOWNLOAD,
    payload: data
  };
};

/**
 * download record giving error sheet
 * @param payload
 * @returns api response
 * @description this function used to download record giving error sheet.
 */
exports.recordsValidationErrorDownload = recordsValidationErrorDownload;
var downloadRecordGivingErrorSheet = function downloadRecordGivingErrorSheet(data) {
  return {
    type: _recordImport.actionTypes.DOWNLOAD_RECORD_GIVING_ERROR_SHEET,
    payload: data
  };
};

/**
 * download record fy error sheet
 * @param payload
 * @returns api response
 * @description this function used to download record fy error sheet.
 */
exports.downloadRecordGivingErrorSheet = downloadRecordGivingErrorSheet;
var downloadRecordFyErrorSheet = function downloadRecordFyErrorSheet(data) {
  return {
    type: _recordImport.actionTypes.RECORDS_FY_VALIDATION_ERROR_DOWNLOAD,
    payload: data
  };
};

/**
 * Reset data
 * @param payload
 * @returns api response
 * @description this function used to reset data.
 */
exports.downloadRecordFyErrorSheet = downloadRecordFyErrorSheet;
var recordImportReset = function recordImportReset() {
  return {
    type: _recordImport.actionTypes.RESET
  };
};
exports.recordImportReset = recordImportReset;